export class User  {
    id: Number;
    login: String;
    name: String;
    password: String;
    cni: String;
    email: String;
    active: Boolean;
    resetPassword: Boolean;
    partner: any;
    params : any;
}
export class Partner {
    id: Number;
    name: String;
    partnerGroupIds : PartnerGroup[];
    
    public toString = () : string => {
        return name ;
    }
}

export class PartnerGroup  {
    id: Number;
    name: String;
    
    
    public toString = () : string => {
        return name ;
    }
}